import { createContext, useContext, useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export const MinuteTickContext = createContext<Dayjs>(dayjs());

export const useMinuteTick = () => {
  const [now, setNow] = useState(() => dayjs());

  useEffect(() => {
    const tick = () => setNow(dayjs());
    const msToNextMinute = 60_000 - (Date.now() % 60_000);
    let interval: number | undefined;
    const timeout = window.setTimeout(() => {
      tick();
      interval = window.setInterval(tick, 60_000);
    }, msToNextMinute);

    return () => {
      window.clearTimeout(timeout);
      if (interval !== undefined) {
        window.clearInterval(interval);
      }
    };
  }, []);

  return now;
};

export const useMinuteTickContext = () => useContext(MinuteTickContext);
